import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Content } from './ModalTemplate.styles';

const ModalTemplate = ({ children }) => {
  return (
    <Wrapper>
      <Content>{children}</Content>
    </Wrapper>
  );
};

ModalTemplate.propTypes = {
  children: PropTypes.object,
};

export default ModalTemplate;
